
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Head from 'next/head';
import useTranslation from 'next-translate/useTranslation';
import TransportBoard from '../components/TransportBoard';
import RelatedLinks from '../components/RelatedLinks';
import { getTransportDepartures } from '../lib/rejseplanenFetcher';
import { SITE_URL } from '../lib/site';
// Server-render the current board so the departures are real, indexable content
// (the homepage/passport board is client-only and invisible to crawlers). ISR
// keeps it fresh-enough for SEO; the component refreshes live on the client.
async function getStaticProps() {
    let departures = [];
    try {
        const data = await getTransportDepartures();
        departures = data.departures;
    }
    catch (error) {
        console.error('Trains page: board fetch failed:', error.message);
    }
    return { props: { departures }, revalidate: 60 };
}
function Trains({ departures }) {
    const { t, lang } = useTranslation('trains');
    const url = lang === 'en' ? `${SITE_URL}/en/trains` : `${SITE_URL}/trains`;
    return (<div className="bg-white p-4 sm:p-6 my-auto rounded max-w-3xl mx-auto text-gray-800">
            <Head>
                <title>{t('meta_title')}</title>
                <meta name="description" content={t('meta_description')}/>
                <meta name="robots" content="all"/>
                <link rel="canonical" href={url}/>
                <meta property="og:title" content={t('meta_title')}/>
                <meta property="og:description" content={t('meta_description')}/>
                <meta property="og:url" content={url}/>
            </Head>

            <h1 className="text-2xl sm:text-3xl font-bold">{t('page_title')}</h1>
            <p className="mt-3 text-gray-600">{t('intro')}</p>

            <TransportBoard initialDepartures={departures}/>

            <section className="mt-8">
                <h2 className="text-xl font-semibold">{t('connections_title')}</h2>
                <ul className="mt-2 list-disc list-inside text-gray-700 *:my-1">
                    <li>{t('connection_copenhagen')}</li>
                    <li>{t('connection_sweden')}</li>
                    <li>{t('connection_metro')}</li>
                </ul>
                <p className="mt-3 text-sm text-gray-500">{t('data_note')}</p>
            </section>

            <RelatedLinks links={[
            {
                href: '/passport-control',
                labelKey: 'link_passport'
            },
            {
                href: '/parking',
                labelKey: 'link_parking'
            }
        ]}/>
        </div>);
}
export default Trains;

    async function __Next_Translate__getStaticProps__1a1723ec6a9__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/trains',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1723ec6a9__ as getStaticProps }
  